import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    currentOrder: { type: String, default: undefined },
    fieldName: { type: String, default: undefined },
    reverse: { type: Boolean, default: undefined },
  },
});
